import { Injectable } from '@angular/core';
import { Client } from '@app/shared';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class DriverNoticeService {


  drivers = {};

  constructor(private client: Client,
    private http: HttpClient) { }

  getDrivers(service) {
    const BS = new BehaviorSubject([]);
    const driversList = this.drivers[service];
    if (driversList) BS.next(driversList);
    else
      this.http.get(this.client.getDriversSearchUrl({ service_id: service })).subscribe((res: any) => {
        const validDrivers = res.data.filter(el => !!el.callsign && !!el.first_name && !!el.last_name);
        this.drivers[service] = validDrivers;
        BS.next(validDrivers);
      });
    return BS;
  }

  sendMessage(drivers, message, service,  priority?) {
    return this.http.post(this.client.getMessageUrl(), {
      drivers: drivers,
      msg: message,
      priority: 1,
      service_id: service
    });
  }

  sendMessageToAll(service, message): any {
    return this.http.post(this.client.getMessageToAllUrl(), {
      service_id: service,
      msg: message,
      priority: 1
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/driver-notice/driver-notice.service.ts